<div class="container-fluid py-4">
  <div class="row">

    <!-- Sidebar -->
    <div class="col-md-3 col-lg-2 mb-4 mb-md-0">
      <div class="card border-0 shadow-sm">
        <div class="card-header bg-dark text-white py-3">
          <div class="d-flex align-items-center gap-2">
            <i class="bi bi-shield-lock-fill"></i>
            <span class="fw-semibold">Admin</span>
          </div>
        </div>
        <div class="list-group list-group-flush">
          <a routerLink="/admin/noun-translations"
             routerLinkActive="active bg-primary text-white"
             class="list-group-item list-group-item-action d-flex align-items-center gap-2 py-3">
            <i class="bi bi-translate"></i>
            <span>Noun Translations</span>
          </a>
          <a routerLink="/admin/noun-examples"
             routerLinkActive="active bg-primary text-white"
             class="list-group-item list-group-item-action d-flex align-items-center gap-2 py-3">
            <i class="bi bi-magic"></i>
            <span>Noun Examples</span>
          </a>
          <a routerLink="/admin/stories"
             routerLinkActive="active bg-primary text-white"
             class="list-group-item list-group-item-action d-flex align-items-center gap-2 py-3">
            <i class="bi bi-card-text"></i>
            <span>DE Stories</span>
          </a>
        </div>
      </div>
    </div>

    <!-- Main content -->
    <div class="col-md-9 col-lg-10">
      <router-outlet></router-outlet>
    </div>

  </div>
</div>
